import { HttpClient } from '@angular/common/http';
import { Component, OnInit, inject } from '@angular/core';

import { UntypedFormGroup, UntypedFormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { debounceTime } from 'rxjs';
import { VendorService } from 'src/app/core/services/vendor.service';
import { Fields } from 'src/app/shared/models/candidateprofile-genmodel';
import { MatFormField, MatLabel, MatInput, MatError } from '@angular/material/input';

@Component({
  selector: 'app-phonenumber',
  standalone: true,
  templateUrl: './phonenumber.component.html',
  styleUrls: ['./phonenumber.component.scss'],
  imports: [MatFormField, ReactiveFormsModule, MatLabel, MatInput, MatError],
})
export class PhonenumberComponent implements OnInit {
  private http = inject(HttpClient);
  private vendorService = inject(VendorService);

  field: Fields;
  group: UntypedFormGroup;
  phoneGroup: any;
  requiredBool: boolean;

  codeControl = new UntypedFormControl('');
  countryCodeJson = {
    name: 'countryCode',
    displayName: 'Code',
    inputType: 'text',
    value: null,
    validations: [
      {
        name: 'required',
        value: 'required',
        message: 'required',
      },
      {
        name: 'pattern',
        value: '^[0-9]{1,5}$',
        message: 'invalid',
      },
    ],
  };
  selectedRole = localStorage.getItem('selectedRole');
  entityId = localStorage.getItem('companyHiringTypeId');
  errorMessage: string;
  jobDetails: any;

  ngOnInit() {
    this.codeControl.setValidators(this.bindValidations());
    this.group.addControl('countryCode', this.codeControl);
    this.group.get('countryCode').valueChanges.subscribe((data) => {
      this.field.validations.forEach((validations) => {
        // console.log("sss1");
        if (validations.name == 'pattern') {
          if (data == 91) {
            validations.value = '^[1-9][0-9]{9,9}$';
            this.group.controls['contactNo'].setValidators([
              Validators.pattern('^[1-9][0-9]{9,9}$'),
              Validators.required,
              Validators.minLength(10),
              Validators.maxLength(10),
            ]);
            this.group.controls['contactNo'].updateValueAndValidity();
          } else {
            validations.value = '^[1-9][0-9]{8,14}$';
            this.group.controls['contactNo'].setValidators([
              Validators.pattern('^[1-9][0-9]{8,14}$'),
              Validators.required,
            ]);
            this.group.controls['contactNo'].updateValueAndValidity();
          }
        }
      });
    });

    this.vendorService._currentDetails.subscribe((data: any) => {
      this.jobDetails = data;
    });

    this.group
      .get(this.field.name)
      .valueChanges.pipe(debounceTime(1500))
      .subscribe((_data) => {
        if (this.group.get(this.field.name).valid) {
          // this.field.url="http://10.47.50.242:8181/validate/validateEmail?email={0}&entityId={1}"
          if (this.selectedRole == 'ROLE_REC_ALL') {
            if (this.field && this.field?.name == 'contactNo') {
              const validateURL = this.field.url;
              console.log(validateURL, 'validate url');
              const countryCode = this.group.get('countryCode').value;
              const mobileNum = this.group.get('contactNo').value;
              const candEmailId = this.group.get('emailId')?.value;
              console.log('+' + countryCode + '-' + mobileNum, 'countryCode, mobileNum');
              const validateObj = {
                email: candEmailId,
                publicationId: this.jobDetails?.publicationId,
                companyHiringTypeId: localStorage.getItem('companyHiringTypeId'),
                contactNo: '+' + countryCode + '-' + mobileNum,
                sourceId: this.jobDetails?.sourceId,
              };
              // "contactNo": "+91-9933223111",
              this.http.post<any>(validateURL, validateObj).subscribe(
                (data) => {
                  console.log(data, 'validate email');
                  if (data?.status == 'Failure') {
                    let validMessageObj = [];
                    // this.field.validations.push({ message: "Applied job is invalid. Please apply for another job.", name: "invalidjob", value: "invalidjob" });
                    const respObj = data?.message.includes('.');
                    if (respObj) {
                      validMessageObj = this.field.validations.filter((dataFields) =>
                        dataFields?.message
                          ?.trim()
                          .replace(/\.$/, '')
                          .toLowerCase()
                          .includes(data?.message?.trim().replace(/\.$/, '').toLowerCase()),
                      );
                    } else {
                      validMessageObj = this.field.validations.filter((dataFields) =>
                        dataFields?.message?.trim().toLowerCase().includes(data?.message?.trim().toLowerCase()),
                      );
                    }
                    const errorName = validMessageObj[0]?.name;
                    this.group.get(this.field.name).setErrors({ [errorName]: true });
                    if (
                      !this.group.get('emailId').hasError('pattern') &&
                      !this.group.get('emailId').hasError('required') &&
                      !this.group.get('emailId').hasError('serviceError')
                    ) {
                      this.group.get('emailId').setErrors(null);
                    }
                  } else {
                    this.group.get(this.field.name).setErrors(null);
                    // let errorName1 = this.group.get("emailId").hasError('pattern')
                    // let errorName2 = this.group.get("emailId").hasError('required')
                    // let errorName3 = this.group.get("emailId").hasError('serviceError')
                    if (
                      !this.group.get('emailId').hasError('pattern') &&
                      !this.group.get('emailId').hasError('required') &&
                      !this.group.get('emailId').hasError('serviceError')
                    ) {
                      this.group.get('emailId').setErrors(null);
                    }
                    // else{

                    // }
                    // this.errorMessage = '';
                  }
                },
                (_error) => {
                  this.group.get(this.field.name).setErrors({ serviceError: true });
                },
              );
            }
          }
        } else {
          // this.errorMessage = '';
        }
      });
  }

  bindValidations() {
    if (this.countryCodeJson.validations.length > 0) {
      const validList = [];
      this.countryCodeJson.validations.forEach((valid) => {
        switch (valid.name) {
          case 'required': {
            validList.push(Validators.required);
            break;
          }
          case 'pattern': {
            validList.push(Validators.pattern(valid.value));
            break;
          }
        }
      });
      return Validators.compose(validList);
    }
  }
}
